import { takeEvery, put, all } from 'redux-saga/effects'
import {
  PASSWORD_VERIFICATION_CHECK,
  PASSWORD_VERIFICATION_CHECK_FAILURE,
  PASSWORD_VERIFICATION_CHECK_LOGIN,
  PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE,
  PASSWORD_VERIFICATION_CHECK_LOGIN_SUCCESS,
  PASSWORD_VERIFICATION_CHECK_SUCCESS,
} from './constants'
import { PasswordVerificationCheckAction, PasswordVerificationLoginAction } from './actions'
import { DateTime } from 'luxon'
import {
  encodeString,
  removeLocalStorageItem,
  setLocalStorageItem,
  TOURNAMENT_STORAGE_KEY_PREFIX,
} from '@app/utils/storage'
import { APIRoute } from '@app/config'
import axios from 'axios'

export const enum ErrorPayload {
  INCORRECT_PASSWORD = 'INCORRECT_PASSWORD',
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
}

function* checkPasswordVerificationForTournament(action: PasswordVerificationCheckAction) {
  try {
    const res = yield axios.get(APIRoute.GET_TOURNAMENT_PASSWORD_VERIFICATION(action.tournamentId))

    if (res.status === 200) {
      yield put({
        type: PASSWORD_VERIFICATION_CHECK_SUCCESS,
        payload: {
          tournamentId: action.tournamentId,
          tournamentName: res.data.tournamentName,
          startTime: res.data.startTime ? DateTime.fromISO(res.data.startTime) : null,
          courseName: res.data.courseName,
          passwordVerification: res.data.passwordVerification,
          heroImage: res.data.heroImage,
          units: res.data.units,
        },
      })
      return
    }

    removeLocalStorageItem(`${TOURNAMENT_STORAGE_KEY_PREFIX}${action.tournamentId}`)
    yield put({
      type: PASSWORD_VERIFICATION_CHECK_FAILURE,
      tournamentId: action.tournamentId,
      error: new Error('Failed to check password verification'),
    })
  } catch (error) {
    removeLocalStorageItem(`${TOURNAMENT_STORAGE_KEY_PREFIX}${action.tournamentId}`)
    if (error.status === 404) {
      yield put({
        type: PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE,
        error: ErrorPayload.PAGE_NOT_FOUND,
      })
      return
    }
    yield put({
      type: PASSWORD_VERIFICATION_CHECK_FAILURE,
      error: error.toString(),
    })
  }
}

function* passwordVerificationLogin(action: PasswordVerificationLoginAction) {
  try {
    const res = yield axios.post(APIRoute.GET_TOURNAMENT_PASSWORD_VERIFICATION(action.tournamentId), {
      password: action.password,
    })

    if (res.status === 200 && res.data.status === 'OK') {
      setLocalStorageItem(
        `${TOURNAMENT_STORAGE_KEY_PREFIX}${action.tournamentId}`,
        encodeString(JSON.stringify({ password: action.password })),
      )
      yield put({
        type: PASSWORD_VERIFICATION_CHECK_LOGIN_SUCCESS,
      })
      return
    }

    removeLocalStorageItem(`${TOURNAMENT_STORAGE_KEY_PREFIX}${action.tournamentId}`)
    yield put({
      type: PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE,
    })
  } catch (error) {
    removeLocalStorageItem(`${TOURNAMENT_STORAGE_KEY_PREFIX}${action.tournamentId}`)
    if (error.status === 401) {
      yield put({
        type: PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE,
        error: ErrorPayload.INCORRECT_PASSWORD,
      })
      return
    }
    yield put({
      type: PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE,
      error: error.toString(),
    })
  }
}

export function* watchPasswordVerification() {
  yield all([
    takeEvery(PASSWORD_VERIFICATION_CHECK, checkPasswordVerificationForTournament),
    takeEvery(PASSWORD_VERIFICATION_CHECK_LOGIN, passwordVerificationLogin),
  ])
}
